import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import * as EntitiesActionTypes from '../../entities/actionTypes'
import {TaskManagementViewMode} from "../constants"
import {arrayToSet, filterMapByKey, filterMapByKeys} from '../../atUtils'
import CustomerProjectSelection from "../../CustomerProjectSelection"

const createReducer = ({
    TASK_MANAGEMENT = {},
}) => {
    const pageSettings = TASK_MANAGEMENT.PAGE_SETTINGS || {}

    const viewerSettings = TASK_MANAGEMENT.VIEWER_SETTINGS || {
        hasEditHierarchyRight: false,
        hasAccessToAllManagementScope: false,
        canAccessCompleteTaskInformation: false,
        noTeamAccess: false,
    }

    const cpPanelClosed = TASK_MANAGEMENT.CP_PANEL_CLOSED || false

    const cpSelectionDefaultState = {
        qualifier: CustomerProjectSelection.Qualifier.ALL,
        customers: [],
        projects: [],
    }

    const taskStatusFilterDefaultState = {
        allSelected: false,
        statusIds: [],
        statusTypes: [],
    }

    const singleCPSelection = TASK_MANAGEMENT.SINGLE_CP_SELECTION || {
        projectId: null,
        customerId: null,
    }

    const initialState = {
        viewMode: pageSettings.viewMode || TaskManagementViewMode.TABLE,

        filterCustomerProjectSelection: pageSettings.customersProjectsSelection || cpSelectionDefaultState,
        singleCustomerProjectSelection: {
            customerId: null,
            projectId: null,
            ...singleCPSelection,
        },
        customerProjectNameFilter: '',
        taskStatusFilter: pageSettings.taskStatusFilter || taskStatusFilterDefaultState,
        taskNameFilter: '',
        lastCreatedTaskIds: {},
        recentlyCreatedTaskIds: {},
        viewerSettings,
        managementAssignments: {
            customers: {},
            projects: {},
            tasks: {}
        },
        showOnlyManageableTasks: false,
        hasManageableTasks: false,
        cpPanelClosed: cpPanelClosed,
        bulkOperationsPanelShown: false,
        recentlyCreatedCustomerIds: [],
        recentlyCreatedProjectIds: [],
        showLoadingMoire: false,
    }

    return handleActions({
        [ActionTypes.SHOW_ONLY_MANAGEABLE_TASKS_SET]: (state, {payload: showOnlyManageableTasks}) => ({
            ...state,
            showOnlyManageableTasks,
        }),
        [ActionTypes.VIEW_MODE_SET]: (state, {payload: viewMode}) => ({
            ...state,
            viewMode,
        }),
        [ActionTypes.SINGLE_CP_SELECTION_CHANGE]: (state, {payload: selection}) => ({
            ...state,
            singleCustomerProjectSelection: selection,
        }),
        [ActionTypes.FILTER_CP_SELECTION_CHANGE]: (state, {payload: selection}) => ({
            ...state,
            filterCustomerProjectSelection: selection,
        }),
        [ActionTypes.CP_NAME_FILTER_SET]: (state, {payload: customerProjectNameFilter}) => ({
            ...state,
            customerProjectNameFilter,
        }),
        [ActionTypes.TASK_STATUS_FILTER_CHANGE]: (state, {payload: taskStatusFilter}) => ({
            ...state,
            taskStatusFilter,
        }),
        [ActionTypes.TASK_NAME_FILTER_CHANGE]: (state, {payload: taskNameFilter}) => ({
            ...state,
            taskNameFilter,
        }),
        [ActionTypes.RECENTLY_CREATED_TASKS_ADD]: (state, {payload: taskIds}) => ({
            ...state,
            recentlyCreatedTaskIds: {
                ...state.recentlyCreatedTaskIds,
                ...arrayToSet(taskIds),
            },
        }),
        [ActionTypes.LAST_CREATED_TASK_IDS_SET]: (state, {payload: lastCreatedTaskIds}) => ({
            ...state,
            lastCreatedTaskIds: {
                ...state.lastCreatedTaskIds,
                ...arrayToSet(lastCreatedTaskIds),
            },
        }),
        [ActionTypes.LAST_CREATED_TASK_IDS_REMOVE]: (state, {payload: lastCreatedTaskId}) => ({
            ...state,
            lastCreatedTaskIds: filterMapByKey(state.lastCreatedTaskIds, lastCreatedTaskId),
        }),
        [ActionTypes.VIEWER_SETTINGS_SET]: (state, {payload: viewerSettings}) => ({
            ...state,
            viewerSettings
        }),
        [ActionTypes.MANAGEMENT_ASSIGNMENTS_SET]: (state, {payload: managementAssignments}) => ({
            ...state,
            managementAssignments
        }),
        [ActionTypes.HAS_MANAGEABLE_TASKS_SET]: (state, {payload: hasManageableTasks}) => ({
            ...state,
            hasManageableTasks
        }),
        [EntitiesActionTypes.TASKS_REMOVE]: (state, {payload: taskIds}) => {
            return {
                ...state,
                recentlyCreatedTaskIds: filterMapByKeys(state.recentlyCreatedTaskIds, taskIds)
            }
        },
        [EntitiesActionTypes.TASKS_CLEAR]: (state) => ({
            ...state,
            recentlyCreatedTaskIds: {}
        }),
        [ActionTypes.CP_PANEL_CLOSED_STATE_CHANGE]: (state, {payload: panelClosed}) => ({
            ...state,
            cpPanelClosed: panelClosed,
        }),
        [ActionTypes.BULK_OPERATIONS_PANEL_SHOWN_SET]: (state, {payload: showed}) => {
            return {
                ...state,
                bulkOperationsPanelShown: showed
            }
        },
        [ActionTypes.RECENTLY_CREATED_CUSTOMER_IDS_SET]: (state, {payload: recentlyCreatedCustomerIds}) => ({
            ...state,
            recentlyCreatedCustomerIds
        }),
        [ActionTypes.RECENTLY_CREATED_PROJECT_IDS_SET]: (state, {payload: recentlyCreatedProjectIds}) => ({
            ...state,
            recentlyCreatedProjectIds
        }),
        [ActionTypes.RECENTLY_CREATED_CUSTOMERS_PROJECTS_CLEAR]: state => ({
            ...state,
            recentlyCreatedCustomerIds: [],
            recentlyCreatedProjectIds: []
        }),
        [ActionTypes.TOGGLE_LOADING_MOIRE]: (state, {payload: show}) => ({
            ...state,
            showLoadingMoire: show,
        }),
    }, initialState)
}

export default createReducer



// WEBPACK FOOTER //
// ./web/js/taskManagement/common/reducer.js